import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-82" data-mp="1ge8uil99ubrf">
      <div className="mx-auto max-w-3xl" data-id="element-83" data-mp="2e0pr1oa6klc4">
        <SectionHeading eyebrow="Dudas frecuentes" title="Preguntas frecuentes de colegas" data-id="element-84" data-mp="2dydb1gnzgl1p" />

        <div className="mt-12 space-y-3" data-id="element-85" data-mp="2429ydgvi940i">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <Reveal key={faq.q} delay={index * 0.04} data-id="element-86" data-mp="1z2dtlfezh8jw" data-mpi={index}>
                <div className={`overflow-hidden rounded-2xl border-2 bg-white transition-colors duration-200 ease-out ${isOpen ? 'border-brand' : 'border-ink/15'}`} data-id="element-87" data-mp="smv44kuokq93">
                  <h3 data-id="element-88" data-mp="pi7jwmje16pk">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 sm:px-7" data-id="element-89" data-mp="pizfhxczj4fu">
                      <span className="font-display text-lg leading-tight text-ink sm:text-xl" data-id="element-90" data-mp="6qww4e8yla1w">
                        {faq.q}
                      </span>
                      <span className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-ink transition-[transform,background-color,color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand text-white' : 'bg-volt text-ink'}`} data-id="element-91" data-mp="bk9hmficd0qf">
                        <PlusIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-92" data-mp="3nzk3zow0hbd6" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-93" data-mp="1potd4i6o6z48">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-94" data-mp="1krkted5vin0v">
                        <p className="px-6 pb-6 text-base leading-relaxed text-ink/70 sm:px-7" data-id="element-95" data-mp="1zg7ih6layt5a">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}